import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { useTable, useSortBy, useGlobalFilter } from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import moment from "moment";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";


const VoucherStatusHandler = () => {
  const [voucherType, setVoucherType] = useState(null);
  const [voucherData, setVoucherData] = useState([]);
  const pin = localStorage.getItem('pin');
const sewadarId=localStorage.getItem('sewadarId')
const isSameDay = (date1, date2) => {
  return moment(date1).isSame(date2, "day");
};

const handleReverse = async (voucherType, rowData) => {

  
  if (voucherType === "Delivery Challan") {
    const challanDate = rowData.date; // DC date field
    const today = moment();

    if (challanDate && !isSameDay(challanDate, today)) {
      const confirmNote = await Swal.fire({
        icon: "warning",
        title: "Important Note",
        text:
          "This Delivery Challan is not of the same date. After reversing approval, it will be automatically cancelled.",
        showCancelButton: true,
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel",
      });

      if (!confirmNote.isConfirmed) return;
    }
  }

  // 🔐 PIN Confirmation
  const { value: enteredPin } = await Swal.fire({
    text: "Enter your PIN to reverse this voucher. This action cannot be undone.",
    input: "password",
    inputPlaceholder: "Enter PIN",
    inputAttributes: {
      maxlength: 6,
      autocapitalize: "off",
      autocorrect: "off",
    },
    showCancelButton: true,
    confirmButtonText: "Reverse Voucher",
    preConfirm: (value) => {
      if (!value) {
        Swal.showValidationMessage("PIN is required");
        return false;
      }
      if (value !== pin) {
        Swal.showValidationMessage("Invalid PIN");
        return false;
      }
      return value;
    }
  });

  if (!enteredPin) return;

  try {
    const res = await apiClient.post(SERVER_BASE + "/reverseVoucher", {
      voucherType,
      voucherId: rowData.id,
      sewadarId,
    });

    Swal.fire("Success", res.data.message || "Voucher reversed", "success");

    fetchVoucher(voucherType);
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Failed to reverse voucher", "error");
  }
};

const statusFieldMap = {
  "Receipt Voucher": "receiptStatus",
  "Delivery Challan": "isApproved",
  "Event Transaction": "voucherStatus",
  "Addition": "status",
  "Deduction": "status",
  "Gate Pass": "status",
  "Opening Stock": "status",
  "Location Transfer": "status",
  "Status Transfer": "status",
  "Unusable Production": "status",
  "Conversion": "status",
  "Project Requirement": "status",
  "Opening Stock Ledger": "status",
  "Addition Ledger": "status",
  "Deduction Ledger": "status",
};

  
  const voucherColumns = {
    "Receipt Voucher": [
      {
        Header: "Date",
        accessor: "entryDate",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      {
        Header: "RV No",
        accessor: "rvNo",
        Cell: ({ row }) => {
          const d = row.original;
      
          return (
            <Link
              to={`/PreviewExternalReceiptVoucher?voucherId=${d.id}&type=external`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0d6efd", textDecoration: "none" }}
            >
              {d.rvNo}
            </Link>
          );
        },
      },
      { Header: "Ledger Name", accessor: "ledgerName" },
      { Header: "Status", accessor: "receiptStatus" },
    ],

    "Addition": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ref No.", accessor: "draftCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Event", accessor: "purpose" },
      { Header: "Status", accessor: "status" },
    ],

    "Delivery Challan": [
      {
        Header: "Challan No",
        accessor: "refNo",
        Cell: ({ row }) => {
          const d = row.original;
      
          return (
            <Link
              to={`/previewDeliveryChallan?challanId=${d.id}&type=challan`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0d6efd", textDecoration: "none" }}
            >
              {d.prefix}{d.refNo}
            </Link>
          );
        },
      },
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ledger", accessor: "ledger" },
      { Header: "Status", accessor: "isApproved" },
    ],

    "Deduction": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ref No.", accessor: "draftCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Event", accessor: "purpose" },
      { Header: "Status", accessor: "status" },
    ],

    "Gate Pass": [
      {
        Header: "Date",
        accessor: "gatePassDate",
        Cell: ({ value }) => {
          if (!value) return "";
          const date = new Date(value);
          date.setHours(date.getHours() + 5);
          date.setMinutes(date.getMinutes() + 30);
          return moment(date).format("DD-MMM-YY");
        },
      },
      { Header: "GP Number", accessor: "gatePassCode" },
      { Header: "Vehicle Number", accessor: "vehicleNumber" },
      { Header: "Status", accessor: "status" },
    ],

    "Opening Stock": [
      {
        Header: "Date",
        accessor: "createdAt",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ref No.", accessor: "openingStockNo" },
      { Header: "Department", accessor: "department" },
      { Header: "Status", accessor: "status" },
    ],

    "Location Transfer": [
      {
        Header: "Date",
        accessor: "transferDate",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ref No.", accessor: "transferCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Status", accessor: "status" },
    ],

    "Status Transfer": [
      {
        Header: "Date",
        accessor: "transferDate",
        Cell: ({ value }) => (value ? moment(value).format("DD-MMM-YY") : ""),
      },
      { Header: "Ref No.", accessor: "transferCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Location", accessor: "location" },
      { Header: "Status", accessor: "status" },
    ],

    "Event Transaction": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
      },
      { Header: "Ref No.", accessor: "transactionCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Event", accessor: "event" },
      { Header: "Status", accessor: "voucherStatus" },
    ],

    "Unusable Production": [
      {
        Header: "Date",
        accessor: (row) => (row.date ? moment(row.date).format("DD-MMM-YY") : ""),
      },
      { Header: "Production No", accessor: "productionCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Status", accessor: "status" },
    ],

    "Conversion": [
      {
        Header: "Date",
        accessor: (row) =>
          row.createdAt ? moment(row.createdAt).format("DD-MMM-YY") : "",
      },
      { Header: "Conversion No", accessor: "conversionCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Status", accessor: "status" },
    ],

    "Project Requirement": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
      },
      { Header: "Ref No.", accessor: "requirementCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Status", accessor: "status" },
    ],

    "Opening Stock Ledger": [
      {
        Header: "Date",
        accessor: "createdAt",
        Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
      },
      { Header: "Ref No.", accessor: "openingStockNo" },
      { Header: "Ledger", accessor: "ledgerName" },
      { Header: "Status", accessor: "status" },
    ],

    "Addition Ledger": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
      },
      { Header: "Ref No.", accessor: "draftCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Event", accessor: "purpose" },
      { Header: "Status", accessor: "status" },
    ],

    "Deduction Ledger": [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => moment(value).format("DD-MMM-YY"),
      },
      { Header: "Ref No.", accessor: "draftCode" },
      { Header: "Department", accessor: "department" },
      { Header: "Event", accessor: "purpose" },
      { Header: "Status", accessor: "status" },
    ],
  };
  Object.keys(voucherColumns).forEach((key) => {
    voucherColumns[key].push({
      Header: "Reverse",
      accessor: "reverse",
      Cell: ({ row }) => {
        const statusField = statusFieldMap[key];
        const status = row.original[statusField];
  
        // Show button only if status is "Cancelled" OR "Approved"
        if (status === "Cancelled" || status === "Approved" || status === "Final") {
          return (
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => handleReverse(key, row.original)}
            >
              Reverse
            </button>
          );
        }
  
        // Otherwise show nothing
        return null;
      },
    });
  });
  
  

  const voucherOptions = Object.keys(voucherColumns).map((v) => ({
    label: v,
    value: v,
  }));

  const fetchVoucher = async (type) => {
    try {
      const res = await apiClient.post(SERVER_BASE + "/getVoucherData", {
        voucherType: type,
      });

      setVoucherData(res.data.data || []);
    } catch (err) {
      console.error("Error fetching voucher:", err);
    }
  };

  const DataTable = ({ columns, data }) => {
    const memoCols = useMemo(() => columns, [columns]);
    const memoData = useMemo(() => data, [data]);

    const tableInstance = useTable(
      { columns: memoCols, data: memoData },
      useGlobalFilter,
      useSortBy
    );

    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      state,
      setGlobalFilter,
    } = tableInstance;

    return (
      <>
    
                <div className="d-flex justify-content-between mb-2">
                <input
            type="text"
            className="form-control w-75"
            placeholder="Search..."
            value={state.globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
          />
          <div>
            <strong>Showing {rows.length} records</strong>
          </div>


        </div>

        <table className="table table-bordered table-striped" {...getTableProps()}>
          <thead>
            {headerGroups.map((hg) => (
              <tr {...hg.getHeaderGroupProps()}>
                {hg.headers.map((col) => (
                  <th {...col.getHeaderProps(col.getSortByToggleProps())}>
                    {col.render("Header")}
                    {col.isSorted ? (col.isSortedDesc ? " 🔽" : " 🔼") : ""}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    );
  };

  return (
    <div className="formcontainer mt-5">

      {/* HEADER + SELECT */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Voucher Reversal</h5>

        <div style={{ width: "300px" }}>
          <Select
            options={voucherOptions}
            value={voucherType}
            placeholder="Select Voucher Type"
            onChange={(selected) => {
              setVoucherType(selected);
              fetchVoucher(selected.value);
            }}
          />
        </div>
      </div>

      {/* TABLE */}
      {voucherType && (
        <DataTable
          columns={voucherColumns[voucherType.value] || []}
          data={voucherData}
        />
      )}
    </div>
  );
};

export default VoucherStatusHandler;
